export const copyImageToClipboard = src => {
  if (!src) return;
  const item = new ClipboardItem({
    "image/png": fetch(src)
      .then(response => response.blob())
      .then(blob => {
        if (blob.type === "image/png") return blob;
        return new Promise(resolve => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            canvas.getContext("2d").drawImage(img, 0, 0);
            canvas.toBlob(resolve, "image/png");
          };
          img.src = URL.createObjectURL(blob);
        });
      }),
  });
  navigator.clipboard.write([item]);
};

export const copyTextToClipboard = text => {
  if (!text) return;
  navigator.clipboard.writeText(text);
};

export const joinLines = text =>
  text
    ? text
        .split("\n")
        .map(line => line.trim())
        .filter(Boolean)
        .join(", ")
    : text;

export const formatSaleAmount = item => {
  const net = (item.amount ?? 0) - (item.discount ?? 0);
  const currencyCode = item.invoice?.currency?.code || "";
  return `${net.toLocaleString("en-US")} ${currencyCode}`.trim();
};

export const formatValuePrice = valueRecord => {
  if (valueRecord?.value == null) return null;
  const amount = (+valueRecord.value).toLocaleString("en-US");
  const currencyCode = valueRecord.currency?.code || "";
  return `${amount}${currencyCode ? ` ${currencyCode}` : ""}`;
};

export { formatDate } from "../../../../util";
